import { useThemeProps as systemUseThemeProps } from '@mui/system';
import defaultTheme from './defaultTheme';
export default function useThemeProps(_ref) {
  let {
    props,
    name
  } = _ref;
  return systemUseThemeProps({
    props,
    name,
    defaultTheme
  });
}